export interface UserResponse {
  turkcellSubscriberFlag: number;
  countryISO2: string;
  turkcellClubs: any[];
  segment: string;
  msisdn: string;
  settings: {
    songListenQuality: string;
    songOfflineQuality: string;
    songOfflineForOnlyWifi: boolean;
    agent: string;
  };
  loginFacebookId: string;
  onOperatorNetwork: boolean;
  turkcellSubscriber: boolean;
  agreementVersion: string;
  countryCode: string;
  id: number;
  username: string;
  loginEmail: string;
  email: string;
  avatarUrl: string;
  name: string;
  crmProductId: number;
  openId: string;
  gsmOperator: string;
  encryptedId: string;
}

export enum GsmOperator {
  TURKCELL = 'TURKCELL',
  KKTCELL = 'KKTCELL',
  UKRAINE_LIFECELL = 'UKRAINE_LIFECELL',
  BELARUS_LIFE = 'BELARUS_LIFE',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
  ALL = 'ALL',
  GERMANY_LIFECELL = 'GERMANY_LIFECELL'
}



// WEBPACK FOOTER //
// src/app/common/services/user/user.model.ts